// From https://www.w3schools.com/js/js_cookies.asp
const cookieManager = {
    set: (cname:string, cvalue:string|null):void => {
        if (cvalue == null || cvalue == "") return
        document.cookie = cname + "=" + cvalue + "; Path=/; Domain=.soundcorset.com;"
    },
    // TODO: to modify to return null or undefined, not "" if cookie does not exist.
    get: (cname:string):string => {
        const cookies:string[] = decodeURIComponent(document.cookie).split(";").map((c:string) => c.trim())
        const keyStr:string = cname + "="
        return cookies.find((c:string) => c.indexOf(keyStr) == 0)?.replace(keyStr, "") ?? ""
    },

    remove: (cname:string):void => {
        document.cookie = cname + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;" // TODO: Remove this after 2026-01-01. Temporary fix for transition.
        document.cookie = cname + "=; Path=/; Domain=.soundcorset.com; Expires=Thu, 01 Jan 1970 00:00:01 GMT;"
    }
}

export default cookieManager